import React from 'react'

export const MicOff = (props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill={props.fill || 'none'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_34_3890)'>
      <path
        d='M16.425 17.8391C15.3701 18.4361 14.2048 18.8124 13 18.9451V23.0001H11V18.9451C8.97114 18.7176 7.07979 17.8075 5.63618 16.3639C4.19257 14.9203 3.28242 13.0289 3.05501 11.0001H5.07001C5.22591 12.0795 5.63179 13.1075 6.25532 14.0023C6.87885 14.8971 7.70277 15.6339 8.66143 16.1539C9.62008 16.6739 10.687 16.9628 11.777 16.9976C12.8671 17.0323 13.9502 16.812 14.94 16.3541L13.389 14.8041C12.6442 15.0194 11.8595 15.0587 11.0969 14.9186C10.3344 14.7786 9.61479 14.4631 8.9951 13.9972C8.37541 13.5312 7.87257 12.9275 7.52632 12.2338C7.18006 11.5401 6.99988 10.7754 7.00001 10.0001V8.41405L1.39301 2.80805L2.80801 1.39305L22.607 21.1931L21.192 22.6071L16.425 17.8391ZM19.375 15.1601L17.932 13.7181C18.441 12.9081 18.788 11.9881 18.929 11.0001H20.945C20.7799 12.4967 20.2399 13.9275 19.375 15.1601ZM16.465 12.2511L7.68501 3.47105C8.2399 2.52318 9.09146 1.78439 10.1082 1.3688C11.1248 0.953218 12.2501 0.883968 13.3101 1.17175C14.37 1.45953 15.3058 2.08833 15.9727 2.96101C16.6396 3.8337 17.0007 4.9017 17 6.00005L17.001 10.0001C17.0022 10.7819 16.8192 11.553 16.467 12.2511H16.465Z'
        fill={props.fill || 'currentColor'}
      />
    </g>
    <defs>
      <clipPath id='clip0_34_3890'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
